import { c as _c } from "react/compiler-runtime";
import MarkdownToJSX from 'markdown-to-jsx';
import { Fragment, memo } from 'react';
import { Link } from '@/components/ui/link';
import { TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { CommentCodeBlock } from '../comment-section/comment-code-block';
import { CommentTable } from '../comment-section/comment-table';
type MarkdownProps = {
  children: string;
};
export const Markdown = memo(props => {
  const $ = _c(3);
  const {
    children
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      overrides: {
        a: Link,
        pre: CommentCodeBlock,
        table: CommentTable,
        thead: TableHeader,
        tr: TableRow,
        th: TableHead,
        td: TableCell
      },
      disableParsingRawHTML: true,
      wrapper: Fragment
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== children) {
    t1 = <div className="my-3 prose ml-0.5"><MarkdownToJSX options={t0}>{children}</MarkdownToJSX></div>;
    $[1] = children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
});
Markdown.displayName = 'Markdown';